const dartsDescription = `Дротики можно бросать на расстоянии около двадцати футов или стрелять из духовой трубки на расстояние около двадцати пяти футов. Дротики не наносят большого урона, поэтому на них часто наносят опасные или смертельные яды, чтобы сделать их эффективнее.`

module.exports = dartsDescription
